import { Injectable } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { BlockUI, NgBlockUI } from 'ng-block-ui';


@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  public errorMsg ="Service is not available at this time. Please try again later";
  private readonly notifier: NotifierService;
  @BlockUI() blockUI: NgBlockUI;
  constructor(private notifierService: NotifierService, ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
  }

  stopLoaderAndShowError(data) {
    this.notifier.hide('0');
    this.blockUI.stop();

    if (data == "User inactive/expired") {
      this.notifier.notify('error', `Failed! User Inactive/ Expired`);
    }
    else if (data == "Unauthorized access") {
      this.notifier.notify('error', `Login Unsuccessful. Incorrect username or password please login again`);
    }
    else if (data == "Unauthorized") {
      this.notifier.notify('error', `Failed! There was an error with your E-Mail/Password combination. Please try again`);
    }
    else if (data == "Organization and Endpoint combination already exists") {
      this.notifier.notify('error', `Failed! Please select a unique endpoint name for this organization.`);
    }
    else {
      this.notifier.hide('0');
      this.notifier.notify('error', `Failed! ${data}`);
    }
  }

}
